module.exports = __webpack_public_path__ + "static/media/ShardBoardRoom2.cbeb3066.jpg";